import { render, staticRenderFns } from "./GoodsType.vue?vue&type=template&id=7b9330bc&scoped=true&"
import script from "./GoodsType.vue?vue&type=script&lang=js&"
export * from "./GoodsType.vue?vue&type=script&lang=js&"
import style0 from "./GoodsType.vue?vue&type=style&index=0&id=7b9330bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b9330bc",
  null
  
)

/* custom blocks */
import block0 from "./GoodsType.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports